import { createSelector } from 'reselect'
import { Record } from 'immutable'
import { IAdminMSTeamsWelcomeState } from 'store/entities/adminMSTeamsWelcome/interface'

export const getAdminMSTeamsWelcome = (state: any): Record<IAdminMSTeamsWelcomeState> =>
  state.get('adminMSTeamsWelcome')

export const getAdminMSTeamsWelcomeData = createSelector(getAdminMSTeamsWelcome, adminMSTeamsWelcome =>
  adminMSTeamsWelcome.get('data')
)

export const getAdminMSTeamsWelcomePending = createSelector(getAdminMSTeamsWelcome, adminMSTeamsWelcome =>
  adminMSTeamsWelcome.get('pending')
)
